import { Controller } from "@hotwired/stimulus"
import RequestHelper from "../helpers/request_helper.js"

export default class extends Controller {
  static get targets() {
    return ['container', 'modal'];
  }

  addProduct(event) {
    event.preventDefault();
    const url = event.target.closest('a').dataset.url;
    fetch(url, RequestHelper.defaultPostOptions())
      .then(response => response.text())
      .then(html => {
        // html is the "index" partial rendered server-side by our own
        // Subdomain::Collections::ProductsController#create, fetched from a same-origin,
        // server-generated collection_products_path -- not user input.
        this.containerTarget.innerHTML = html;
      })
      .catch(this.logFailedCall);
  }

  removeProduct(event) {
    event.preventDefault();
    const url = event.target.closest('a').dataset.url;
    fetch(url, RequestHelper.defaultDeleteOptions())
      .then(response => response.text())
      .then(html => {
        // html is the "index" partial rendered server-side by our own
        // Subdomain::Collections::ProductsController#destroy, fetched from a same-origin,
        // server-generated collection_product_path -- not user input.
        this.containerTarget.innerHTML = html;
      })
      .catch(this.logFailedCall);
  }

  logFailedCall(response) {
    console.warn(response);
  }

  loadProductInfo(event) {
    // called when the product is clicked and the modal is opened
    const variantUrl = event.target.closest('a').getAttribute("href");
    this.retrieveVariant(variantUrl);
  }

  retrieveVariant(url) {
    fetch(url, RequestHelper.defaultRequestOptions())
      .then(response => response.text())
      .then(html => {
        // html is the "show" partial rendered server-side by our own
        // Subdomain::Collections::ProductsController#show, fetched from a same-origin,
        // server-generated subdomain_product_path -- not user input.
        this.modalTarget.querySelector(".modal-content").innerHTML = html;
      })
      .catch(this.logFailedCall);
  }
}
